import React from "react";
import AppTitle from "./AppTitle";
import TownHouse from "./TownHouse";
import Levels from "./Levels";
import Buildings from "./Buildings";
import Bedrooms from "./Bedrooms";

const DataContainer = (props) => {

	let data = null;
	if (props.dataType === 'apartments') {
		data = <TownHouse data={props.data} status={props.selectedApp.statusOptions} statusChange={props.statusChange} dataType={props.dataType}/>;
	} else if (props.dataType === 'levels') {
		data = <Levels data={props.data} status={props.selectedApp.statusOptions} statusChange={props.statusChange} appName={props.selectedApp.name}/>;
	} else if (props.dataType === 'buildings') {
		data = <Buildings data={props.data} status={props.selectedApp.statusOptions} statusChange={props.statusChange} appName={props.selectedApp.name}/>;
	} else if (props.dataType === 'bedrooms') {
		data = <Bedrooms data={props.data} status={props.selectedApp.statusOptions} statusChange={props.statusChange} appName={props.selectedApp.name} dataType={props.dataType}/>;
	}

	return (
		<div className={'data-container'}>
			<AppTitle title={props.selectedApp.name}/>
			{data}
		</div>
	);
};

export default DataContainer;